module.exports = "/_next/static/images/game-1-intro-tutorial-underline3-ecbd8baa42a5f84a0d8737bf795928a1.png";